import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from '@/store/modules/auth'

const dataState = new createPersistedState({
    //Persistimos únicamente las variables que necesitamos
    reducer: state => ({
        auth: {
            token: state.auth.token,
            refreshToken: state.auth.refreshToken
        }
    })
})

export default createStore({
    plugins: [dataState],
    state: {
        isLoading: false,
        loadingTimeout: null,
    },
    mutations: {
        setLoading(state, bool) {
            if (bool) {
                clearTimeout(state.loadingTimeout)
                state.loadingTimeout = setTimeout(function() {
                    state.isLoading = true
                }, 300)
            } else {
                clearTimeout(state.loadingTimeout)
                state.isLoading = false
            }
        }
    },
    actions: {
        setLoading({ commit }, isLoading) {
            commit('setLoading', isLoading, { root: true })
        }
    },
    modules: {
        auth
    }
})
